// EditArtlistImage.jsx
import useTranslations from '@/i18n/useTranslations';
import ArtlistImage from '@/shared-components/cards/components/ArtlistImage';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './components/VirtualList';

import './index.css';

export default function EditArtlistImage({
  formState,
  scrollableDiv,
  readOnly,
  croppedUrl,
  loading,
  onImageToCropClick,  // Destructure the prop
  openArtworkImages, 
  setOpenArtworkImages
}) {
  const t = useTranslations('common.profile.pages.artlist');
  const artlistImage = croppedUrl ||
                      formState.artlist_image?.image_id ||
                      formState.artlist_image?.image_url;
  
  return (
    <>
      <div className={`edit-artlist-image__wrap ${readOnly ? "read-only" : ""}`}>
        <ArtlistImage
          className="edit-artlist-image__image"
          image={artlistImage}
          loading={loading}
        />
        
        {Boolean(formState.artlist_image) && (
          <Text
            className="edit-artlist__change-image-button element-non-selectable"
            onClick={() => {
              scrollableDiv.current.scrollTo({ top: 0, behavior: "smooth" });
              setOpenArtworkImages(true);
            }}>
            {t('edit_image.actions.change_cover_picture')}
          </Text>
        )}

        {openArtworkImages && (
          <div className="edit-artlist__change-image-bottom-sheet">
            <div className="edit-artlist__change-image-bottom-sheet-header">
              <Text
                className="edit-artlist__change-image-bottom-sheet-header-text">
                {t('edit_image.bottom_sheet.title')}
              </Text>
              <XIcon className="edit-artlist__change-image-bottom-sheet-close" onClick={() => setOpenArtworkImages(false)} />
            </div>
            <div className="edit-artlist__change-image-bottom-sheet-content-container">
              <VirtualList 
                formState={formState} 
                onSelectImage={onImageToCropClick}  // Pass the function as onSelectImage
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
